/**
 * @generated SignedSource<<80d7bca0435016cf859052b013c34f8b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CryptoTransfersTransactionStatus = "CANCELED" | "FINISHED" | "NOT_CONFIRMED" | "ON_HOLD" | "PENDING" | "PROCESSING" | "REFUNDED" | "REJECTED";
export type CryptoTransfersTransactionType = "DEPOSIT" | "WITHDRAWAL";
export type NotificationType = "CORPORATE_ACTION" | "CRYPTO_ACTION" | "CRYPTO_TRANSFER" | "FIAT_TRANSFER" | "NEW_LEGAL_DOCUMENTS" | "NON_USER_INITIATED_TRANSACTION" | "ORDER" | "REPORT" | "SAVINGS_PLAN";
export type NotificationsInput = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  type?: NotificationType | null | undefined;
};
export type UnreadCryptoTransfersNotificationsQuery$variables = {
  input?: NotificationsInput | null | undefined;
};
export type UnreadCryptoTransfersNotificationsQuery$data = {
  readonly notificationsV3: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly content: {
          readonly cryptoTransferType?: CryptoTransfersTransactionType;
          readonly status?: CryptoTransfersTransactionStatus;
          readonly transferId?: string;
        } | null | undefined;
        readonly id: string;
        readonly readAt: TimeScalar | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly unreadCount: number | null | undefined;
  } | null | undefined;
};
export type UnreadCryptoTransfersNotificationsQuery = {
  response: UnreadCryptoTransfersNotificationsQuery$data;
  variables: UnreadCryptoTransfersNotificationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transferId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cryptoTransferType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "CryptoTransferNotificationV3Content",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnreadCryptoTransfersNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NotificationV3Connection",
        "kind": "LinkedField",
        "name": "notificationsV3",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationV3Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationV3",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnreadCryptoTransfersNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NotificationV3Connection",
        "kind": "LinkedField",
        "name": "notificationsV3",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationV3Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationV3",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6bdf22367a41d879bbcf8836edecf803",
    "id": null,
    "metadata": {},
    "name": "UnreadCryptoTransfersNotificationsQuery",
    "operationKind": "query",
    "text": "query UnreadCryptoTransfersNotificationsQuery(\n  $input: NotificationsInput\n) {\n  notificationsV3(input: $input) {\n    unreadCount\n    edges {\n      node {\n        readAt\n        id\n        content {\n          __typename\n          ... on CryptoTransferNotificationV3Content {\n            transferId\n            cryptoTransferType\n            status\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a3a38599048c124d9f20bb0e677caef4";

export default node;
